import React, { forwardRef, memo, useImperativeHandle, useState } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { washHub } from 'store/slices';

import { updateCustomer } from 'api/customers';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { Customer } from 'types/user';
import { RefType, EditCustomerModalProps } from './EditCustomerModal.props';

import EditCustomerModalView from './EditCustomerModal.view';

const Container = forwardRef<RefType, EditCustomerModalProps>((_, ref) => {
  const queryClient = useQueryClient();
  const washHubs = washHub.selectors.useAllWashHubs();
  const washHubId = washHub.selectors.useSelectedWashHubId();

  const [customer, setCustomer] = useState<Customer | null>(null);

  const { isOpen, onOpen, onClose } = useDisclosure();

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (_customer) => {
        setCustomer(_customer);

        onOpen();
      },
    }),
    [onOpen],
  );

  const { mutate, isLoading } = useMutation(updateCustomer, {
    onSuccess: () => {
      successToast('Customer Updated Successfully');

      queryClient.invalidateQueries(`fetch-customers-${washHubId}`);

      queryClient.invalidateQueries(`fetch-customers-${washHubId}-select`, {
        exact: true,
      });

      onClose();
    },
  });

  const _props = {
    isOpen,
    customer,
    onClose,
    washHubs,
    isLoading,
    onUpdate: async (payload: any) => {
      mutate({
        ...payload,
        _id: customer?._id,
      });
    },
  };

  return <EditCustomerModalView {..._props} />;
});

const EditCustomerModal = memo(Container);

export default EditCustomerModal;
